const t = "input", n = "input__wrapper", p = "input__input", i = "input__label", _ = "input__hint", u = "input__error", r = {
  input: t,
  "input--no-margin": "input--no-margin",
  input__wrapper: n,
  "input--disabled": "input--disabled",
  input__input: p,
  "input--error": "input--error",
  input__label: i,
  "input__label-wrapper": "input__label-wrapper",
  input__hint: _,
  "input__input--auto-size": "input__input--auto-size",
  input__error: u,
  "input__error-text": "input__error-text",
  "input__clear-button": "input__clear-button"
};
export {
  r as default,
  t as input,
  u as input__error,
  _ as input__hint,
  p as input__input,
  i as input__label,
  n as input__wrapper
};
